import { useEffect, useRef } from 'react';
import './BounceCards.css';

export default function BounceCards({
  className = '',
  projects = [],
  containerWidth = 400,
  containerHeight = 400,
  transformStyles = [
    'rotate(10deg) translate(-170px)',
    'rotate(-5deg)',
    'rotate(10deg) translate(170px)'
  ]
}) {
  const containerRef = useRef(null);
  
  useEffect(() => {
    const cards = containerRef.current?.querySelectorAll('.bounce-card');
    if (!cards) return;

    cards.forEach((card, idx) => {
      card.style.opacity = '0';
      card.style.transform = 'scale(0)';
      
      setTimeout(() => {
        card.style.transition = 'all 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55)';
        card.style.opacity = '1';
        card.style.transform = transformStyles[idx] || 'none';
      }, idx * 150 + 300);
    });
  }, [transformStyles]);

  const handleMouseEnter = (idx) => {
    const cards = containerRef.current?.querySelectorAll('.bounce-card');
    if (!cards) return;

    cards.forEach((card, i) => {
      if (i === idx) {
        const baseTransform = transformStyles[i] || 'none';
        const noRotation = baseTransform.replace(/rotate\([^)]*\)/, 'rotate(0deg)');
        card.style.transform = noRotation;
        card.style.zIndex = '10';
      } else {
        const offsetX = i < idx ? -160 : 160;
        const baseTransform = transformStyles[i] || 'none';
        const translateMatch = baseTransform.match(/translate\(([-0-9.]+)px\)/);
        const currentX = translateMatch ? parseFloat(translateMatch[1]) : 0;
        const newTransform = baseTransform.replace(
          /translate\([^)]*\)/,
          `translate(${currentX + offsetX}px)`
        );
        card.style.transform = newTransform;
      }
    });
  };

  const handleMouseLeave = () => {
    const cards = containerRef.current?.querySelectorAll('.bounce-card');
    if (!cards) return;

    cards.forEach((card, i) => {
      card.style.transform = transformStyles[i] || 'none';
      card.style.zIndex = '1';
    });
  };

  return (
    <div
      className={`bounce-cards-container ${className}`}
      ref={containerRef}
      style={{
        width: containerWidth,
        height: containerHeight
      }}
    >
      {projects.map((project, idx) => (
        <a
          key={idx}
          href={project.url}
          target="_blank"
          rel="noopener noreferrer"
          className={`bounce-card bounce-card-${idx}`}
          onMouseEnter={() => handleMouseEnter(idx)}
          onMouseLeave={handleMouseLeave}
        >
          <img className="bounce-card-image" src={project.image} alt={project.title} />
          <div className="bounce-card-overlay">
            <h3 className="bounce-card-title">{project.title}</h3>
          </div>
        </a>
      ))}
    </div>
  );
}